import { render, staticRenderFns } from "./QuestionnaireNew.vue?vue&type=template&id=33a84426&"
import script from "./QuestionnaireNew.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireNew.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports